import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AdminGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private message: NzMessageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isRoleAdmin()) {
      return true;
    }
    this.router.navigate(['/fox-admin/login'], {
      queryParams: {
        returnUrl: state.url,
      },
    });
    this.message.error('アクセス権がありません。');
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isRoleAdmin()) {
      return true;
    }
    this.router.navigate(['/fox-admin/login'], {
      queryParams: {
        returnUrl: state.url,
      },
    });
    this.message.error('アクセス権がありません。');
    return false;
  }
}
